import script from "./ExternalNspkSender.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExternalNspkSender.vue?vue&type=script&setup=true&lang=ts"

import "./ExternalNspkSender.vue?vue&type=style&index=0&id=598401a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598401a4"]])

export default __exports__